import { apiRequest } from './client';
import type { EffectTriggerResult, GameNpcList, Npc } from '../types';

export function fetchNpcs() {
  return apiRequest<Npc[]>('/api/npcs', { auth: true });
}

export function createNpc(payload: Partial<Npc>) {
  return apiRequest<Npc>('/api/npcs', { method: 'POST', auth: true, body: payload });
}

export function updateNpc(id: number, payload: Partial<Npc>) {
  return apiRequest<Npc>(`/api/npcs/${id}`, { method: 'PUT', auth: true, body: payload });
}

export function deleteNpc(id: number) {
  return apiRequest<{ success: boolean }>(`/api/npcs/${id}`, { method: 'DELETE', auth: true });
}

export function fetchGameNpcs(gameId: number) {
  return apiRequest<GameNpcList>(`/api/games/${gameId}/npcs`, { auth: true });
}

export function addNpcToGame(gameId: number, npcId: number, count = 1) {
  return apiRequest<Npc>(`/api/games/${gameId}/npcs`, {
    method: 'POST',
    auth: true,
    body: { npc_id: npcId, count },
  });
}

export function setGameNpcHealth(gameId: number, gameNpcId: number, health: number) {
  return apiRequest<Npc>(`/api/games/${gameId}/npcs/${gameNpcId}/health`, {
    method: 'PUT',
    auth: true,
    body: { health },
  });
}

export function removeNpcFromGame(gameId: number, gameNpcId: number) {
  return apiRequest<{ success: boolean }>(`/api/games/${gameId}/npcs/${gameNpcId}`, {
    method: 'DELETE',
    auth: true,
  });
}

export function triggerNpcEffect(gameId: number, gameNpcId: number, effectId: number) {
  return apiRequest<EffectTriggerResult>(
    `/api/games/${gameId}/npcs/${gameNpcId}/effects/${effectId}/trigger`,
    { method: 'POST', auth: true },
  );
}

export function revokeNpcEffect(gameId: number, gameNpcId: number, effectId: number) {
  return apiRequest<{ message: string; effects: unknown[] }>(
    `/api/games/${gameId}/npcs/${gameNpcId}/effects/${effectId}`,
    { method: 'DELETE', auth: true },
  );
}
